import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store'
import { identifyPostHogUser, initPostHog, resetPostHogUser } from '../lib/posthog'

/**
 * Sync Redux auth state to PostHog. Renders nothing. Route changes need no wiring here — the SDK
 * captures pageviews off the history API itself (capture_pageview in lib/posthog).
 */
export default function PostHogAuthBridge() {
  const user = useSelector((state: RootState) => state.auth.user)
  const wasSignedIn = useRef(false)

  useEffect(() => {
    initPostHog()
  }, [])

  useEffect(() => {
    if (user) {
      identifyPostHogUser(user)
      wasSignedIn.current = true
      return
    }
    // Only a genuine sign-out resets. A null user on first render is just auth still resolving, and
    // resetting there would throw away the anonymous id carried over on the shared .replay.io
    // cookie — the identity this integration exists to preserve.
    if (!wasSignedIn.current) return
    wasSignedIn.current = false
    resetPostHogUser()
  }, [user])

  return null
}
